import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../api/axiosInstance";

export default function UserList() {
  const [appointmentsSheduled, setAppointmentsSheduled] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  // Fetch users
  useEffect(() => {
    const fetchAppointmentsSheduled = async () => {
      try {
        const res = await axiosInstance.get("admin/booked-appointments");
        console.log(res.data);
        setAppointmentsSheduled(res.data || []);
      } catch (err) {
        console.error("Failed to fetch users:", err);
        toast.error("Failed to fetch users.");
      } finally {
        setLoading(false);
      }
    };
    fetchAppointmentsSheduled();
  }, []);



  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen text-gray-500">
        Loading appointments...
      </div>
    );
  }
  const groupedAppointments = appointmentsSheduled?.appointments.reduce(
    (acc: any, appointment: any) => {
      const date = appointment.date || "Unknown Date";

      if (!acc[date]) {
        acc[date] = [];
      }

      acc[date].push(appointment);
      return acc;
    },
    {}
  );
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-6xl mx-auto bg-white shadow-md rounded-xl p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          📅 Appointment List {appointmentsSheduled.from} - {appointmentsSheduled.to}
        </h2>

        {Array.isArray(appointmentsSheduled?.appointments) && appointmentsSheduled?.appointments?.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">
              <thead className="bg-indigo-100">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Profile</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Patient Name</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Date</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Phone</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Appointment Time</th>
                  <th className="px-6 py-3 text-center text-sm font-semibold text-gray-700">Doctor</th>
                  <th className="px-6 py-3 text-center text-sm font-semibold text-gray-700">Specialisation</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {Object.entries(groupedAppointments || {}).map(
                  ([date, appointments]: any) => (
                    <React.Fragment key={date}>

                      {/* Date Header Row */}
                      <tr className="bg-gray-100">
                        <td
                          colSpan={7}
                          className="px-6 py-2 text-sm font-semibold text-gray-700"
                        >
                          {date}
                        </td>
                      </tr>

                      {/* Appointments for that Date */}
                      {appointments.map((appointment: any) => (
                        <tr key={appointment.phone} className="hover:bg-gray-50">
                          <td className="px-6 py-3">
                            <img
                              src={appointment.patient.profile}
                              alt={appointment.patient.name}
                              className="w-12 h-12 rounded-full object-cover border"
                            />
                          </td>
                          <td className="px-6 py-3 text-gray-800">
                            {appointment.patient.name || "—"}
                          </td>
                          <td className="px-6 py-3 text-gray-800">
                            {appointment.date || "—"}
                          </td>
                          <td className="px-6 py-3 text-gray-600">
                            {appointment.patient?.phone}
                          </td>
                          <td className="px-6 py-3 text-gray-600">
                            {appointment.start} - {appointment.end}
                          </td>
                          <td className="px-6 py-3 text-gray-600">
                            {appointment.doctor?.name}
                          </td>
                          <td className="px-6 py-3 text-center">
                            {appointment.doctor?.specialisation}
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  )
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-gray-500 text-center py-6">No appointment found.</p>
        )}
      </div>
    </div>
  );
}
